import type { ReactNode } from 'react';

export const symbol_pin_invoke: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M140-160q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h430q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H140v520h680v-270q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v270q0 24-18 42t-42 18H140Zm400-297L416-333q-9 9-21 8.5t-21.39-9.5q-8.61-9-8.61-21t9-21l124-124h-74q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h146q12.75 0 21.38 8.62Q600-542.75 600-530v146q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-73Zm230-123q-45 0-77.5-32.08Q660-644.17 660-690q0-45 32.5-77.5t78-32.5q45.5 0 77.5 32.5t32 78q0 45.5-32.08 77.5-32.09 32-77.92 32Z"
		/>
	</svg>
);
